import { createSlice } from '@reduxjs/toolkit'
import { requestMyProjects } from '../lib/api/work.js';
import { FileSystem, VersionAction } from "../fs/fs";
import { createHost } from "../fs/host";
import { deployment } from "../deployment";
import { fetchMicroPython } from "../micropython/micropython";

export const projectStore = createSlice({
    name: 'project-store',
    initialState: {
        // 项目名称
        title: 'main.py',
        // 项目id
        mataProjectId: null,
        writeState: false,
        titleOld: '',
        // 我的作品
        projectNamesList: []
    },
    reducers: {
        setProjectTitle: (state, action) => {
            var newFilename = action.payload.replace(".py", "");
            state.title = newFilename
        },
        setProjectTitleold: (state, action) => {
            state.titleOld = action.payload
        },
        setMataProjectId: (state, action) => {
            state.mataProjectId = action.payload
        },
        setWriteState: (state, action) => {
            state.writeState = action.payload
        },
        setProjectNamesList: (state, action) => {
            state.projectNamesList = action.payload
        }
    }
})

export const {
    setProjectTitle,
    setMataProjectId,
    setWriteState,
    setProjectTitleold,
    setProjectNamesList
} = projectStore.actions
export default projectStore.reducer